import React from "react";
import { Button, Result } from "antd";
import { MetaTags } from "react-meta-tags";
const NotFound = () => {
  return (
    <div>
      <MetaTags>
        <title>Not found | Mequals</title>
      </MetaTags>

      <Result
        status="404"
        title="404"
        style={{
          fontFamily: "Poppins",
        }}
        subTitle="Sorry, the page you visited does not exist."
        extra={
          <Button type="primary">
            <a href="/employee-dashboard">Back Home</a>
          </Button>
        }
      />
    </div>
  );
};

export default NotFound;
